import React from 'react'
import PropTypes from 'prop-types'
import {
  QUICK_VIEW_VISIBLE_TRACK_ROWS,
  QuickViewTrackList,
  QuickViewSkeletonRow,
  QuickViewSkeletonBlock
} from './QuickViewModal.styles'

export default function QuickViewTrackListSkeleton({
  responsiveBreakpointsV2,
  rowCount
}) {
  return (
    <QuickViewTrackList
      $responsiveBreakpointsV2={responsiveBreakpointsV2}
      data-testid="quick-view-track-list">
      {Array.from({ length: rowCount }).map((_, index) => (
        <QuickViewSkeletonRow
          key={`quick-view-skeleton-${index}`}
          $responsiveBreakpointsV2={responsiveBreakpointsV2}
          data-testid="quick-view-skeleton-row">
          <QuickViewSkeletonBlock $width={12} />
          <div className="flex flex-col gap-2 min-w-0">
            <QuickViewSkeletonBlock $width={index % 2 === 0 ? '52%' : '44%'} />
            <QuickViewSkeletonBlock
              $dimmed
              $width={index % 2 === 0 ? '30%' : '24%'} />
          </div>
          <QuickViewSkeletonBlock $width={28} />
          <div className="hidden md:flex items-center justify-end gap-1">
            <QuickViewSkeletonBlock $height={18} $width={78} />
            <QuickViewSkeletonBlock $height={18} $width={36} />
          </div>
          <QuickViewSkeletonBlock $width={16} />
        </QuickViewSkeletonRow>
      ))}
    </QuickViewTrackList>
  )
}

QuickViewTrackListSkeleton.propTypes = {
  responsiveBreakpointsV2: PropTypes.bool,
  rowCount: PropTypes.number
}

QuickViewTrackListSkeleton.defaultProps = {
  responsiveBreakpointsV2: false,
  rowCount: QUICK_VIEW_VISIBLE_TRACK_ROWS
}
